import React from 'react'
import { QrcodeOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import { connect } from 'react-redux'
import './style.scss'

function SideBar(props) {
  const { personalize } = props
  const qrcodeContent = (
    <div className="sidebar-qrcode">
      <img src={require('../../assets/images/mini-program-qrcode.jpg')} alt=""/>
      <div className="tac">微信扫一扫</div>
      <div className="tac">登录设备平台移动版</div>
    </div>
  )

  return (
    <div className="sidebar">
      {(personalize && personalize.domain) ? '' : (
        <div className="sidebar-menu">
          <div className="sidebar-menu-item">
            <Popover content={qrcodeContent} placement="left">
              <QrcodeOutlined/>
            </Popover>
          </div>
        </div>
      )}
    </div>
  )
}

export default connect(state => ({
  personalize: state.getIn(['common', 'personalize'])
}))(SideBar)
